import MaterialDetails from "./MaterialDetails";
import DataPanel from "../DataPanel";

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
    options: {}
  },
  {
    name: 'density',
    label: 'Gęstość [kg/m3]',
    options: {}
  },
  {
    name: 'unitPrice',
    label: 'Cena za centymetr',
    options: {}
  },
  {
    name: 'kilogramPrice',
    label: 'Cena za kilogram',
    options: {}
  }
];

const MaterialsPanel = () => {
  return (
    <DataPanel
      tableSearchEnabled
      title='Pianki poliuretanowe'
      resource='materials'
      columns={columns}
      renderDetails={(props) => <MaterialDetails { ...props } />}
    />
  );
};
export default MaterialsPanel;